
import { Phone } from "lucide-react";

export const BusinessHours = () => {
  return (
    <div className="bg-white p-8 rounded-lg shadow-lg border border-[#e0f2fe]">
      <h3 className="text-2xl font-medium mb-6 text-[#0c4a6e]">Horario de atención</h3>
      
      <div className="space-y-3">
        <div className="flex justify-between">
          <span className="text-[#64748b]">Lunes - Viernes</span>
          <span className="font-medium text-[#0c4a6e]">9:00 AM - 6:00 PM</span>
        </div>
        <div className="flex justify-between">
          <span className="text-[#64748b]">Sábado</span>
          <span className="font-medium text-[#0c4a6e]">10:00 AM - 2:00 PM</span>
        </div>
        <div className="flex justify-between">
          <span className="text-[#64748b]">Domingo</span>
          <span className="font-medium text-[#0c4a6e]">Cerrado</span>
        </div>
      </div>
      
      <div className="mt-6 pt-6 border-t border-[#e0f2fe]">
        <a 
          href="tel:+17865695142" 
          className="inline-flex items-center justify-center w-full rounded-md bg-[#0c4a6e] hover:bg-[#0c4a6e]/90 text-white py-2"
        >
          <Phone className="mr-2 h-4 w-4" />
          Llamar Ahora
        </a>
      </div>
    </div>
  );
};
